import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import { ASK_TROVIX_SETTINGS_PERMISSIONS } from "./permissions";

import type { FeatureMetadata } from "@/features/feature.types";
import { buildCrudPermissions } from "@/features/shared/featureFactories";

export const AskTrovixSettingsFeature = {
  id: "ask-trovix-settings",
  moduleName: "ai",
  navigation: {
    label: "Ask Trovix settings",
    path: "/ask-trovix-settings",
    icon: AdjustmentsHorizontalIcon,
    order: 2,
  },
  // Read-only: one key opens the menu entry, the route and both requests. There is nothing to create, edit or delete.
  permissions: buildCrudPermissions("AI", "Settings", {
    view: ASK_TROVIX_SETTINGS_PERMISSIONS.view,
    create: ASK_TROVIX_SETTINGS_PERMISSIONS.view,
    edit: ASK_TROVIX_SETTINGS_PERMISSIONS.view,
    delete: ASK_TROVIX_SETTINGS_PERMISSIONS.view,
  }),
  route: {
    path: "/ask-trovix-settings",
    element: lazy(() => import("./pages/AskTrovixSettings")),
  },
  readiness: "live",
} as const satisfies FeatureMetadata;
